export default "__VITE_ASSET__9033ce10__"